import { Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import {
  BillingContainer,
  DashboardContainer,
  FaqContainer,
  HelpAndSupportContainer,
  InviteFriendsContainer,
  AffiliateContainer,
  PackageContainer,
  ProfileContainer,
  StoreContainer,
} from '@src/containers';
import * as URLS from '@src/constants/URLS.const';
import { ESimsContainer } from '@src/containers/ESimsContainer/ESimsContainer';
import { Layout } from '@src/layout';

function NavigateWithQuery({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
}

export function DashboardRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route
          index
          element={
            <Suspense fallback={null}>
              <DashboardContainer />
            </Suspense>
          }
        />
        <Route
          path={URLS.ROUTE_STORE_BASE_URL}
          element={
            <Suspense fallback={null}>
              <StoreContainer />
            </Suspense>
          }
        />
        <Route
          path={URLS.ROUTE_PACKAGE_BASE_URL}
          element={
            <Suspense fallback={null}>
              <PackageContainer />
            </Suspense>
          }
        />
        <Route
          path={URLS.ROUTE_ORDER_RESULT_BASE_URL}
          element={
            <NavigateWithQuery to={`/${URLS.ROUTE_ORDER_RESULT_BASE_URL}`} />
          }
        />

        <Route
          path={URLS.ROUTE_MY_ESIMS_BASE_URL}
          element={
            <Suspense fallback={null}>
              <ESimsContainer />
            </Suspense>
          }
        />
        <Route
          path={URLS.ROUTE_PROFILE_BASE_URL}
          element={
            <Suspense fallback={null}>
              <ProfileContainer />
            </Suspense>
          }
        />
        <Route
          path={URLS.ROUTE_BILLING_BASE_URL}
          element={
            <Suspense fallback={null}>
              <BillingContainer />
            </Suspense>
          }
        />
        <Route
          path={URLS.ROUTE_INVITE_FRIENDS_BASE_URL}
          element={
            <Suspense fallback={null}>
              <InviteFriendsContainer />
            </Suspense>
          }
        />
        <Route
          path={URLS.ROUTE_AFFILIATE_BASE_URL}
          element={
            <Suspense fallback={null}>
              <AffiliateContainer />
            </Suspense>
          }
        />
        <Route
          path={URLS.ROUTE_HELP_AND_SUPPORT_BASE_URL}
          element={
            <Suspense fallback={null}>
              <HelpAndSupportContainer />
            </Suspense>
          }
        />
        <Route
          path={URLS.ROUTE_FAQ_BASE_URL}
          element={
            <Suspense fallback={null}>
              <FaqContainer />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}
